module.exports = __webpack_public_path__ + "img/welcome_23.2cb23969.jpg";